import { createTheme } from '@mui/material/styles';

import { themeOverrides as asiaGamesTheme } from 'components/selector/asia-games/mui/theme';
import { themeOverrides as captainAmericaTheme } from 'components/selector/captain-america/mui/theme';
import { themeOverrides as casinoExeTheme } from 'components/selector/casinoexe/mui/theme';
import { themeOverrides as dragonSkillTheme } from 'components/selector/dragon-skill/mui/theme';
import { themeOverrides as firekirinTheme } from 'components/selector/firekirin/mui/theme';
import { themeOverrides as h24CasinoTheme } from 'components/selector/h24casino/mui/theme';
import { themeOverrides as liveTheme } from 'components/selector/savanna/mui/theme';
import { themeOverrides as realBetTheme } from 'components/selector/realbet/mui/theme';
import { themeOverrides as rivieraTheme } from 'components/selector/riviera/mui/theme';
import { themeOverrides as royaleSlotsTheme } from 'components/selector/royale-slots/mui/theme';
import { themeOverrides as savannaTheme } from 'components/selector/savanna/mui/theme';
import { themeOverrides as sbslotTheme } from 'components/selector/sbslot/mui/theme';
import { themeOverrides as starGameMobileTheme } from 'components/selector/stargame_mobile/mui/theme';
import { themeOverrides as starGameTheme } from 'components/selector/stargame/mui/theme';
import { themeOverrides as superVegasTheme } from 'components/selector/supervegas/mui/theme';
import { themeOverrides as theGoldCityTheme } from 'components/selector/thegoldcity/mui/theme';
import { themeOverrides as vegaswinTheme } from 'components/selector/vegaswin/mui/theme';

export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    xxl: 1920,
    xxxl: 2560,
  },
};

export const createMuiTheme = (selectorThemeId) => {
  let props = {};

  switch (selectorThemeId) {
    case "stargame":
      props = starGameTheme;
      break;
    case "stargame_mobile":
      props = starGameMobileTheme;
      break;
    case "riviera":
      props = rivieraTheme;
      break;
    case "firekirin":
    case "firekirinPlusLive":
    case "firekirinLive":
      props = firekirinTheme;
      break;
    case "dragon-skill":
      props = dragonSkillTheme;
      break;
    case "captain-america":
      props = captainAmericaTheme;
      break;
    case "asia-games":
      props = asiaGamesTheme;
      break;
    case "supervegas":
    case "luckywinner":
      props = superVegasTheme;
      break;
    case "savanna":
    case "savannaPro":
      props = savannaTheme;
      break;
    case "live":
      props = liveTheme;
      break;
    case "royale-slots":
      props = royaleSlotsTheme;
      break;
    case "sbslot":
      props = sbslotTheme;
      break;
    case "casinoexe":
      props = casinoExeTheme;
      break;
    case "thegoldcity":
      props = theGoldCityTheme;
      break;
    case "realbet":
      props = realBetTheme;
      break;
    case "h24casino":
      props = h24CasinoTheme;
      break;
    case "vegaswin":
      props = vegaswinTheme;
      break;
    default:
      props = starGameTheme;
      break;
  }
  props = {
    ...props,
    breakpoints
  };

  return createTheme(props);
}

